import React from 'react'
import PropTypes from 'prop-types'
import ContentBox from '../../../layout/component/ContentBox'
import Select from '../../../form/component/Select'

const RECOMMENDATIONS = [
    {
        id:'goOnNextAligners',
        value: 'GO ON - Next aligners despite slight displacement'
    },
    {
        id:'goOnUseChewies',
        value: 'GO ON & RECOMMENDATION - Use Chewies'
    },
    {
        id:'goOnUseChewiesOnTeeth',
        value: 'GO ON & RECOMMENDATION - Use Chewies on teeth with displacement'
    },
    {
        id:'goOnIncreaseAndUseChewies',
        value: 'GO ON & RECOMMENDATION - Increase wearing duration per day and use Chewies'
    },
    {
        id:'goOnIncrease',
        value: 'GO ON & RECOMMENDATION - Increase wearing duration per day'
    },
    {
        id:'goOnPZR',
        value: 'GO ON & RECOMMENDATION - PZR needed'
    },
]

const AlignerSendRecommendationWidget = ({ customer, saveTreatmentExecutionClarificationComment }) => {

    const treatmentExecutionList = customer.treatmentExecutionList

    if (treatmentExecutionList.length === 0) {
        return null
    }

    const alignerCheckins = treatmentExecutionList[treatmentExecutionList.length - 1].alignerCheckInList
    alignerCheckins.sort((a, b) => new Date(a.checkinDate) - new Date(b.checkinDate))

    const clarificationComment = alignerCheckins[alignerCheckins.length - 1].clarificationComment

    return (
        <ContentBox title="Choose recommendation">
            <Select
                object={{ clarificationComment }}
                name="clarificationComment"
                valueList={RECOMMENDATIONS}
                addEmpty={true}
                onChange={(name, value) => {
                    saveTreatmentExecutionClarificationComment(value)
                }}
            />
        </ContentBox>
    )
}

AlignerSendRecommendationWidget.propTypes = {
    customer: PropTypes.object.isRequired,
    saveTreatmentExecutionClarificationComment: PropTypes.func.isRequired,
}

export default AlignerSendRecommendationWidget



// WEBPACK FOOTER //
// ./src/modules/customer/component/task-widget/AlignerSendRecommendationWidget.js